/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AppReleaseControllerDownloadCurrentChannelAsset$Params {
  channel: string;
  platform: string;
  arch: string;
  fileName: string;
}

export function appReleaseControllerDownloadCurrentChannelAsset(http: HttpClient, rootUrl: string, params: AppReleaseControllerDownloadCurrentChannelAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, appReleaseControllerDownloadCurrentChannelAsset.PATH, 'get');
  if (params) {
    rb.path('channel', params.channel, {});
    rb.path('platform', params.platform, {});
    rb.path('arch', params.arch, {});
    rb.path('fileName', params.fileName, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

appReleaseControllerDownloadCurrentChannelAsset.PATH = '/api/app-releases/channels/current/{channel}/{platform}/{arch}/assets/{fileName}';
